import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-6 py-4 text-sm font-bold tracking-wider uppercase transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-brand-gold text-brand-dark hover:bg-brand-goldLight shadow-[0_0_20px_rgba(197,160,89,0.3)] hover:shadow-[0_0_30px_rgba(197,160,89,0.5)]',
    secondary: 'bg-brand-red text-white hover:bg-red-800 shadow-[0_0_20px_rgba(153,27,27,0.3)]',
    outline: 'border border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-dark'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-130" data-mp="39k9eq9uu57p9">
      <span className="relative z-10 flex items-center gap-2" data-id="element-131" data-mp="34lg18hfjtgp3">
        {children}
        {icon && <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-132" data-mp="30hhzdyyu9rsc" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-133" data-mp="2qlopyogf2ees" />}
    </button>;
}
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  darker?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  darker = false
}: SectionProps) {
  return <section id={id} className={`py-8 md:py-14 px-4 md:px-8 ${darker ? 'bg-brand-dark' : 'bg-brand-anthracite'} ${className}`} data-id="element-134" data-mp="27tcd37s4zuqe">
      <div className="max-w-4xl mx-auto" data-id="element-135" data-mp="22xx3is15wkzs">{children}</div>
    </section>;
}